var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{ 'beethoven-success': _vm.success, 'beethoven-fail': !_vm.success && _vm.failed },style:(_vm.style),attrs:{"alt":_vm.alt,"data-testid":_vm.dataTestid,"loading":_vm.loading,"src":_vm.computedSrc,"width":_vm.computedWidth,"height":_vm.computedHeight},on:{"load":_vm.onLoad,"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }